import { Outlet } from "react-router-dom";
import DsSidebar from "./DsSidebar";
import DsTopBar from "./DsTopBar";

/**
 * DsShell — 셸 레이아웃 (범위3).
 *
 * 데스크톱(lg+): 좌측 사이드바 + 본문.
 * 모바일: 상단 바(로고 + 메뉴☰) + 본문. (QCC-6: 하단 탭바 제거 — 답답함 해소로
 *   세로 64px 회수. nav 는 상단바 메뉴로 이동, 전체 라우트 제공해 갇히지 않게.)
 *
 * B-3a: /settings·/qcc·/more 신규 라우트에만 적용. 기존 화면은 B-3b 에서 이주.
 */
export default function DsShell() {
  return (
    <div
      className="flex flex-col lg:flex-row min-h-[100dvh]"
      style={{ background: "var(--ds-canvas-soft)" }}
    >
      <DsSidebar />
      <DsTopBar />
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
